import { ProductDetailsState } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../store/rootReducer";
import { API_URL } from "config";
import { Product } from "features/ProductReel/types";

const initialState: ProductDetailsState = {
  fetchedProduct: {} as Product,
  fetchedProductLoading: false,
};

const productDetails = createSlice({
  name: "productsSlice",
  initialState,
  reducers: {
    setFetchedProduct(state, action: PayloadAction<Product>) {
      state.fetchedProduct = action.payload;
      state.fetchedProductLoading = false;
    },
    setFetchedProductLoading(state, action) {
      state.fetchedProductLoading = action.payload;
    },
  },
});
export const {
  setFetchedProduct,
  setFetchedProductLoading,
} = productDetails.actions;

export const selectFetchedProduct = (state: RootState) =>
  state.productDetails.fetchedProduct;
export const selectFetchedProductLoading = (state: RootState) =>
  state.productDetails.fetchedProductLoading;

export const fetchProductDetails = (alias: string) => async (dispatch: any) => {
  dispatch(setFetchedProductLoading(true));
  try {
    const result = await axios.get(`${API_URL}/products/${alias}`);
    dispatch(setFetchedProduct(result.data.data));
  } catch (error: any) {
    dispatch(setFetchedProductLoading(false));
    console.log(`Error in fetchReelProducts: ${error.message}`);
  }
};

export default productDetails.reducer;
